import React, { useEffect, useRef, useState } from 'react';

import { GrowthBook, GrowthBookProvider } from '@growthbook/growthbook-react';
import { analytics } from '@features/analytics';
import { useSelector } from 'react-redux';
import { basketSelectors } from '@store/basket/selectors';
import Cookies from 'js-cookie';

type FeatureFlagProviderProps = {
  children: React.ReactNode;
  clientKey: string;
  siteSlug: string;
};

export function FeatureFlagProvider({ children, clientKey, siteSlug }: FeatureFlagProviderProps) {
  const orderReference = useSelector((state) => basketSelectors.getOrder(state)?.orderReference);
  const appliedOrderReference = useRef<string | undefined>(undefined);

  const [gb] = useState(() => {
    return new GrowthBook({
      apiHost: 'https://growthbook-proxy.control.onejourney.travel',
      clientKey,
      attributes: { id: Cookies.get('gbuuid'), siteSlug },
      trackingCallback: (experiment, result) => {
        analytics.track({
          event: 'experiment_viewed',
          params: {
            experiment_id: experiment.key,
            variation_id: result.variationId,
            site_slug: siteSlug,
          },
        });
      },
    });
  });

  const [ready, setReady] = useState(false);

  useEffect(() => {
    gb.init({ streaming: false, timeout: 2000 })
      .then(() => setReady(true))
      .catch(() => setReady(true));
  }, [gb]);

  useEffect(() => {
    if (!ready) return;
    if (appliedOrderReference.current === orderReference) return;

    appliedOrderReference.current = orderReference;
    gb.updateAttributes({ orderReference });
  }, [gb, ready, orderReference]);

  if (!ready) return null;

  return <GrowthBookProvider growthbook={gb}>{children}</GrowthBookProvider>;
}
